import { render, staticRenderFns } from "./matchingEntrance.vue?vue&type=template&id=6b86ba56&scoped=true&"
import script from "./matchingEntrance.vue?vue&type=script&lang=js&"
export * from "./matchingEntrance.vue?vue&type=script&lang=js&"
import style0 from "./matchingEntrance.vue?vue&type=style&index=0&id=6b86ba56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b86ba56",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/matching/components/matchingEntrance.vue
// module id = null
// module chunks = 